module.exports = __webpack_public_path__ + "static/img/brscan-logo.6db2e5bf.png";